document.addEventListener('DOMContentLoaded', function() {
    // Get the rating container
    const ratingContainer = document.querySelector('.gh-article-meta-rating');

    if (!ratingContainer) return;

    const likeButton = ratingContainer.querySelector('.gh-rating-btn.like');
    const dislikeButton = ratingContainer.querySelector('.gh-rating-btn.dislike');
    const ratingScore = ratingContainer.querySelector('.rating-score');
    const ratingValue = document.querySelector('.rating-value');
    const postId = ratingContainer.getAttribute('data-post-id');

    // Initialize counts from localStorage or set to default
    let likes = parseInt(localStorage.getItem(`post-likes-${postId}`) || 0);
    let dislikes = parseInt(localStorage.getItem(`post-dislikes-${postId}`) || 0);

    // Fetch real stats from backend
    fetch(`/api/analytics/stats/${postId}`)
        .then(res => res.json())
        .then(data => {
            if (data) {
                likes = data.likes || 0;
                dislikes = data.dislikes || 0;
                localStorage.setItem(`post-likes-${postId}`, likes);
                localStorage.setItem(`post-dislikes-${postId}`, dislikes);
                updateScoreDisplay();
            }
        })
        .catch(err => console.error('Error fetching stats:', err));

    // Update display
    updateScoreDisplay();

    // Load existing user rating
    const savedRating = localStorage.getItem(`post-rating-${postId}`);
    if (savedRating !== null) {
        updateRating(parseInt(savedRating));
    }

    // Add event listeners
    if (likeButton) {
        likeButton.addEventListener('click', function() {
            const value = parseInt(this.getAttribute('data-value'));
            if (this.classList.contains('active')) {
                resetRating();
            } else {
                saveRating(value);
            }
        });
    }

    if (dislikeButton) {
        dislikeButton.addEventListener('click', function() {
            const value = parseInt(this.getAttribute('data-value'));
            if (this.classList.contains('active')) {
                resetRating();
            } else {
                saveRating(value);
            }
        });
    }

    // Reset rating
    function resetRating() {
        const currentRating = localStorage.getItem(`post-rating-${postId}`);

        if (currentRating === '1') {
            likes = Math.max(0, likes - 1);
            localStorage.setItem(`post-likes-${postId}`, likes);
        } else if (currentRating === '0') {
            dislikes = Math.max(0, dislikes - 1);
            localStorage.setItem(`post-dislikes-${postId}`, dislikes);
        }

        localStorage.removeItem(`post-rating-${postId}`);
        likeButton.classList.remove('active');
        dislikeButton.classList.remove('active');
        updateScoreDisplay();

        // Remove from backend
        fetch('/api/analytics/rate/remove', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ postId: postId })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                likes = data.likes;
                dislikes = data.dislikes;
                updateScoreDisplay();
            }
        })
        .catch(console.error);
    }

    // Save rating
    function saveRating(value) {
        const currentRating = localStorage.getItem(`post-rating-${postId}`);

        if (currentRating !== null) {
            if (currentRating === '1') likes--;
            else if (currentRating === '0') dislikes--;
        }

        if (value === 1) likes++;
        else if (value === 0) dislikes++;

        localStorage.setItem(`post-likes-${postId}`, likes);
        localStorage.setItem(`post-dislikes-${postId}`, dislikes);
        localStorage.setItem(`post-rating-${postId}`, value);

        updateRating(value);
        updateScoreDisplay();

        fetch('/api/analytics/rate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ postId: postId, rating: value })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                likes = data.likes;
                dislikes = data.dislikes;
                updateScoreDisplay();
            }
        })
        .catch(console.error);
    }

    // Update UI
    function updateRating(value) {
        likeButton.classList.remove('active');
        dislikeButton.classList.remove('active');

        if (value === 1) likeButton.classList.add('active');
        else if (value === 0) dislikeButton.classList.add('active');
    }

    // Update Score Display
    function updateScoreDisplay() {
        if (ratingScore) {
            const score = Math.max(0, likes - dislikes);
            ratingScore.textContent = score > 0 ? `${score}` : score;

            // Optional: Color coding
            if (score > 0) ratingScore.style.color = '#10b981'; // Green
            else ratingScore.style.color = 'inherit';
        }
    }
});